// extracted by mini-css-extract-plugin
export default {"contentRightBody":"styles_contentRightBody__W+O0F","headerControls":"styles_headerControls__gF+Ao"};